import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

interface LoadingScreenProps {
  message?: string;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ message = 'Loading iBusiness...' }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: 'linear-gradient(27deg, #166cb1 39%, #11aae2 73%, #12d9b8)',
      }}
    >
      <CircularProgress 
        size={60} 
        sx={{ color: 'white', mb: 2 }}
        aria-label={`loading ${message.toLowerCase()}`}
        role="progressbar"
      />
      <Typography 
        variant="h6" 
        sx={{ color: 'white' }}
        aria-live="polite"
      >
        {message}
      </Typography>
    </Box>
  );
};

export default LoadingScreen;
